import { GqlSageInvoiceAgingReminderService } from '../../modules/graphql/services/sage-invoice-aging-reminder';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { IApiAgingInvoiceEmailTemplate, IApiAgingNoticeInput, IApiSageInvoiceAgingReminderConnection, IApiSageInvoiceAgingReminderFilter } from "../../modules/graphql/types/types";
import { IGqlBaseOptions } from '../../modules/graphql/interfaces';

@Injectable()
export class SageInvoiceAgingReminderService {

    constructor(
        private gqlSageInvoiceAgingReminderService: GqlSageInvoiceAgingReminderService
    ) { }

    public getAgingEmailTemplates(): Observable<IApiAgingInvoiceEmailTemplate[]> {
        return this.gqlSageInvoiceAgingReminderService.getAgingEmailTemplates();
    }

    public sendAgingInvoiceNotice(input: IApiAgingNoticeInput): Observable<{ success: boolean, message: string }> {
        return this.gqlSageInvoiceAgingReminderService.sendAgingInvoiceNotice(input);
    }

    public sageInvoiceAgingReminders(filters: IApiSageInvoiceAgingReminderFilter[], options: IGqlBaseOptions): Observable<IApiSageInvoiceAgingReminderConnection> {
        return this.gqlSageInvoiceAgingReminderService.sageInvoiceAgingReminders(filters, options);
    }

}
